import React, { useState } from "react";
import { useSelector } from "react-redux";

import { DropDownField } from "../helpers";

import { Tooltip } from "primereact/tooltip";

import { numberConversion } from "../utils";

import { getPMCompanyConfig } from "../setup/pmCompanyConfig";


const DispatchDetailsDisplay = (props) => {
    const { warehouseStatus, currentWarehouse, userRelatedWarehouses, getWarehouseStatusDetails, selectedWarehouse, handleWarehouseInputChange, isWarehouseEditable, setIsWarehouseEditable } = props

    const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale, currencySymbol } = pmCompanyConfig

    const handleSaveWarehouse = () => {
        setIsWarehouseEditable(false)
        getWarehouseStatusDetails()
    }

    return (
        <div className="flex ml-2 mb-2 mobile-display-container" style={{width: "" }}>
            <div className="flex flex-row justify-between items-center mobile-display-container">
                <div className="flex flex-column md:flex-row gap-2 mobile-display-container">
                    <div className="flex flex-column p-0 m-0 mr-1 mt-2" style={{ width: '', height: 'px' }}>
                        {/* <div className="flex col-12 lg:mb-0" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                            <span className="font-bold"> Current WH :</span><span className="ml-2">{currentWarehouse}</span>
                        </div> */}
                        <div className="flex col-12 lg:mb-0 p-0 align-content-center ml-1 warehouse-field">
                            {/* <label htmlFor="warehouseId" className="font-bold col-12 md:col-4 lg:col-5 pr-0" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                                Warehouse :
                            </label> */}
                            <div className="p-0 warehouse-dropdown">
                                <DropDownField name="warehouseId" labelText="Warehouse :" placeholder={"Please Select"} options={userRelatedWarehouses} optionLabel="warehouseName" optionValue="warehouseId" value={selectedWarehouse} onChange={(e) => handleWarehouseInputChange(e)} showClear disabled={!isWarehouseEditable}/>
                            </div>
                            <div className="mt-3" style={{cursor: 'pointer'}}>
                            {
                                isWarehouseEditable ? 
                                <i className="pi pi-save pl-2 mt-2" style={{ fontSize: '1.0rem', cursor: "pointer" }} onClick={() => handleSaveWarehouse()}/>
                                :
                                <i className="pi pi-file-edit pl-2 mt-2" style={{ fontSize: '1.0rem', cursor: "pointer" }} onClick={() => setIsWarehouseEditable(true)}/>
                            }
                            </div>
                        </div>
                    </div>
                    <div className="status-cards-container">
                    {/* <div className="flex flex-row items-center p-2 mb-2" style={{ height: '60px'}}>
                        <img
                            src={RefreshImg}
                            alt=""
                            style={{ height: '30px', width: '30px', borderRadius: '50%', marginLeft: -3, marginTop: -8, cursor: 'pointer', transition: 'transform 0.2s, background-color 0.2s'}}
                            onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = '#f0f0f0'
                            }}
                            onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = ''
                                e.currentTarget.style.transform = 'scale(1)'
                            }}
                            onMouseDown={(e) => {
                                e.currentTarget.style.transform = 'scale(0.95)'
                                e.currentTarget.style.backgroundColor = '#d3d3d3'
                            }}
                            onMouseUp={(e) => {
                                e.currentTarget.style.transform = 'scale(1)'
                                e.currentTarget.style.backgroundColor = '#f0f0f0'
                                getWarehouseStatusDetails()
                            }}
                        />
                    </div> */}
                    <div className="status-box flex-1 p-2 followup-status-card summary-card" >
                        <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0" >
                            FollowUps Status:<i className="pi pi-info-circle custom-tooltip-followup" aria-hidden="true"></i>
                            <br />
                            {warehouseStatus.followUpDetails?.[0].remaining_follow_ups ? warehouseStatus.followUpDetails?.[0].remaining_follow_ups : 0}({warehouseStatus.followUpDetails?.[0].uniqueSellerCompanies ? warehouseStatus.followUpDetails?.[0].uniqueSellerCompanies : 0})/{warehouseStatus.followUpDetails?.[0].follow_ups_done_today ? warehouseStatus.followUpDetails?.[0].follow_ups_done_today : 0}
                        </h3>
                        <Tooltip target={`.custom-tooltip-followup`} position="top" autoHide>
                            Follow Ups Pending (Num of Unique Sellers)/ Follow Ups Done Today
                        </Tooltip>
                    </div>
                    <div className="status-box flex-1 p-2 grn-card summary-card">
                        <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0">GRNs:<i className="pi pi-info-circle custom-tooltip-grn" aria-hidden="true"></i>
                            <br /> {currencySymbol}
                            {warehouseStatus.grnDetails?.[0].value ? numberConversion(warehouseStatus.grnDetails?.[0].value, numberLocale) : 0}({warehouseStatus.grnDetails?.[0].total_grn_done_today ? warehouseStatus.grnDetails?.[0].total_grn_done_today : 0})
                        </h3>
                        <Tooltip target={`.custom-tooltip-grn`} position="top" autoHide>
                            GRN Amount Today (Num of GRN)
                        </Tooltip>
                    </div>
                    <div className="status-box flex-1 p-2 dispatches-card summary-card">
                        <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0">
                            Dispatches:<i className="pi pi-info-circle custom-tooltip-dispatches" aria-hidden="true"></i>
                            <br /> {currencySymbol}
                            {warehouseStatus.dispatchData?.[0].value ? numberConversion(warehouseStatus.dispatchData?.[0].value, numberLocale) : 0}({warehouseStatus.dispatchData?.[0].total_dispatch_notes ? warehouseStatus.dispatchData?.[0].total_dispatch_notes : 0})
                        </h3>
                        <Tooltip target={`.custom-tooltip-dispatches`} position="top" autoHide>
                            Total Dispatched Today (Total number of Dispatch Notes)
                        </Tooltip>
                    </div>
                    <div className="status-box flex-1 p-2 dispatched-card summary-card" >
                        <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0">
                            Dispatched/Ready for PU:<i className="pi pi-info-circle custom-tooltip-ready-for-pu" aria-hidden="true"></i>
                            <br /> {currencySymbol}
                            {warehouseStatus.readyForInwardData?.[0].value ? numberConversion(warehouseStatus.readyForInwardData?.[0].value, numberLocale) : 0}({warehouseStatus.readyForInwardData?.[0].total_inward_items ? warehouseStatus.readyForInwardData?.[0].total_inward_items : 0})
                        </h3>
                        <Tooltip target={`.custom-tooltip-ready-for-pu`} position="top" autoHide>
                            Value of Items available for Inward (Num of items available for inward)
                        </Tooltip>
                    </div>
                    <div className="status-box flex-1 p-2 pending-dispatch summary-card" >
                        <h3 className="font-bold text-center mb-1 text-gray-700 text-xs m-0">
                            Pending Dispatch:<i className="pi pi-info-circle custom-tooltip-pending-dispatch" aria-hidden="true"></i>
                            <br /> {currencySymbol}
                            {warehouseStatus.pendingDispatchData?.[0].value ? numberConversion(warehouseStatus.pendingDispatchData?.[0].value, numberLocale) : 0}({warehouseStatus.pendingDispatchData?.[0].pending_dispatch_count ? warehouseStatus.pendingDispatchData?.[0].pending_dispatch_count : 0})
                        </h3>
                        <Tooltip target={`.custom-tooltip-pending-dispatch`} position="top" autoHide>
                            Pending Dispatch Value (Num of Items Inwarded, but not yet Dispatched)
                        </Tooltip>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DispatchDetailsDisplay